/* Menu A/B — resolves the Intelligems test group and applies one header.
   Control (and every failure path) keeps the old header; variant swaps in
   Menu Nav 2.0. The resolved group is cached so later loads paint the right
   header before this script runs. */

(function () {
  var html = document.documentElement;
  var EXPERIMENT = html.getAttribute('data-menu-ab-experiment');
  var CACHE_KEY = 'ctr:menu-ab:' + EXPERIMENT;
  var TIMEOUT_MS = 8000;

  if (html.getAttribute('data-menu-ab-mode') !== 'ab-test') return;
  // In the editor, keep both sections in the DOM so they stay selectable.
  if (window.Shopify && window.Shopify.designMode) return;

  function igReady() {
    return window.igData && window.igData.user && typeof window.igData.user.getTestGroup === 'function';
  }

  function waitForIgReady() {
    return new Promise(function (resolve) {
      if (igReady()) return resolve();

      var poll;
      var done = function () {
        clearInterval(poll);
        resolve();
      };
      document.addEventListener('ig:ready', done, { once: true });
      poll = setInterval(function () {
        if (igReady()) done();
      }, 100);
      setTimeout(done, TIMEOUT_MS);
    });
  }

  function applyControl() {
    html.classList.remove('ctr-menu-new');
    var ctr = document.querySelector('.shopify-section.ctr-menu-nav-2');
    // Removal also runs the nav element's disconnectedCallback cleanup.
    if (ctr) ctr.remove();
  }

  function applyVariant() {
    html.classList.add('ctr-menu-new');
    var oldWrap = document.querySelector('.shopify-section[id$="__header"]');
    if (oldWrap) {
      oldWrap.classList.remove('section-header');
      // Keep the section wrapper: cart-notification and scripts live in it.
      var headerEl = oldWrap.querySelector('.header-wrapper');
      if (headerEl) headerEl.remove();
    }
    // The nav initialized while hidden; remeasure now that it is visible.
    window.dispatchEvent(new Event('resize'));
  }

  waitForIgReady().then(function () {
    var variant = false;
    var resolved = false;

    try {
      if (EXPERIMENT && igReady()) {
        var group = window.igData.user.getTestGroup(EXPERIMENT);
        if (group) {
          variant = !group.isControl;
          resolved = true;
        }
      }
    } catch (e) {
      // Fall through to control.
    }

    if (variant) applyVariant();
    else applyControl();

    // Cache only real resolutions so an IG hiccup can't pin a visitor.
    if (resolved) {
      try {
        localStorage.setItem(CACHE_KEY, variant ? 'variant' : 'control');
      } catch (e) {}
    }
  });
})();
